/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Active_Plans_MessageInputs */

const en_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have any active plans.`)
};

const id_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda tidak memiliki rencana aktif.`)
};

const ms_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda tidak mempunyai sebarang pelan aktif.`)
};

const ca_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tens cap pla actiu.`)
};

const cs_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemáte žádné aktivní plány.`)
};

const da_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du har ingen aktive abonnementer.`)
};

const de_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben keine aktiven Pläne.`)
};

const et_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teil pole ühtegi aktiivset plaani.`)
};

const es_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tienes ningún plan activo.`)
};

const fr_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n’avez aucun abonnement en cours.`)
};

const hr_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemate aktivnih planova.`)
};

const it_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai piani attivi.`)
};

const lv_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jums nav aktīvu plānu.`)
};

const lt_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neturite jokių aktyvių planų.`)
};

const hu_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincsenek aktív tervei.`)
};

const nl_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt geen actieve abonnementen.`)
};

const nb_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du har ingen aktive abonnementer.`)
};

const pl_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie masz żadnych aktywnych planów.`)
};

const pt_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não tem nenhum plano ativo.`)
};

const ro_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu aveți niciun plan activ.`)
};

const sk_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemáte žiadne aktívne plány.`)
};

const sl_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nimate aktivnih načrtov.`)
};

const fi_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinulla ei ole aktiivisia suunnitelmia.`)
};

const sv_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du har inga aktiva planer.`)
};

const vi_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn không có bất kỳ kế hoạch hoạt động nào.`)
};

const tr_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif bir planınız yok.`)
};

const el_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεν έχετε ενεργά πλάνα.`)
};

const bg_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нямате активни планове.`)
};

const ru_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У вас нет активных планов.`)
};

const sr_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немате активне планове.`)
};

const uk_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У вас немає активних планів.`)
};

const ka_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენ არ გაქვთ აქტიური გეგმები.`)
};

const hi_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी कोई सक्रिय योजना नहीं है।`)
};

const th_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณไม่มีแผนที่ใช้งานอยู่`)
};

const ko_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활성 플랜이 없습니다.`)
};

const zh_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您没有任何有效的套餐。`)
};

const zh_tw_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您沒有任何有效方案。`)
};

const ja_no_active_plans_message = /** @type {(inputs: No_Active_Plans_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効なプランがありません。`)
};

/**
* | output |
* | --- |
* | "You don't have any active plans." |
*
* @param {No_Active_Plans_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const no_active_plans_message = /** @type {((inputs?: No_Active_Plans_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Active_Plans_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_no_active_plans_message(inputs)
	if (locale === "ms") return ms_no_active_plans_message(inputs)
	if (locale === "ca") return ca_no_active_plans_message(inputs)
	if (locale === "cs") return cs_no_active_plans_message(inputs)
	if (locale === "da") return da_no_active_plans_message(inputs)
	if (locale === "de") return de_no_active_plans_message(inputs)
	if (locale === "et") return et_no_active_plans_message(inputs)
	if (locale === "es") return es_no_active_plans_message(inputs)
	if (locale === "fr") return fr_no_active_plans_message(inputs)
	if (locale === "hr") return hr_no_active_plans_message(inputs)
	if (locale === "it") return it_no_active_plans_message(inputs)
	if (locale === "lv") return lv_no_active_plans_message(inputs)
	if (locale === "lt") return lt_no_active_plans_message(inputs)
	if (locale === "hu") return hu_no_active_plans_message(inputs)
	if (locale === "nl") return nl_no_active_plans_message(inputs)
	if (locale === "nb") return nb_no_active_plans_message(inputs)
	if (locale === "pl") return pl_no_active_plans_message(inputs)
	if (locale === "pt") return pt_no_active_plans_message(inputs)
	if (locale === "ro") return ro_no_active_plans_message(inputs)
	if (locale === "sk") return sk_no_active_plans_message(inputs)
	if (locale === "sl") return sl_no_active_plans_message(inputs)
	if (locale === "fi") return fi_no_active_plans_message(inputs)
	if (locale === "sv") return sv_no_active_plans_message(inputs)
	if (locale === "vi") return vi_no_active_plans_message(inputs)
	if (locale === "tr") return tr_no_active_plans_message(inputs)
	if (locale === "el") return el_no_active_plans_message(inputs)
	if (locale === "bg") return bg_no_active_plans_message(inputs)
	if (locale === "ru") return ru_no_active_plans_message(inputs)
	if (locale === "sr") return sr_no_active_plans_message(inputs)
	if (locale === "uk") return uk_no_active_plans_message(inputs)
	if (locale === "ka") return ka_no_active_plans_message(inputs)
	if (locale === "hi") return hi_no_active_plans_message(inputs)
	if (locale === "th") return th_no_active_plans_message(inputs)
	if (locale === "ko") return ko_no_active_plans_message(inputs)
	if (locale === "zh") return zh_no_active_plans_message(inputs)
	if (locale === "zh-tw") return zh_tw_no_active_plans_message(inputs)
	if (locale === "ja") return ja_no_active_plans_message(inputs)
	return en_no_active_plans_message(inputs)
});